const $ = jQuery;
document.addEventListener("DOMContentLoaded", (event) => {
	const siteHeader = document.querySelector(".site-header");
	if (siteHeader) {
		const toggleBtn = siteHeader.querySelector(".mobile-menu-toggler");
		const menuContainer = siteHeader.querySelector("#main-menu-container");
		const mainMenu = siteHeader.querySelector("#site-main-menu");

		toggleBtn.addEventListener("click", toggleMobileNav.bind({ toggleBtn, menuContainer }));
		mainMenu.addEventListener("click", expandMenuItem.bind({ mainMenu }));
		mainMenu.addEventListener("keyup", CloseSubmenuOnKeypress.bind({ mainMenu }));
	}
});

/**
 *
 * Mobile Menu toggle
 */
function toggleMobileNav(e) {
	e.preventDefault();
	const { toggleBtn: btn, menuContainer } = this;
	btn.classList.toggle("expanded");

	if (btn.classList.contains("expanded")) {
		btn.setAttribute("aria-expanded", true);
		menuContainer.classList.add("expanded");
	} else {
		btn.setAttribute("aria-expanded", false);
		menuContainer.classList.remove("expanded");
	}
}

/**
 *
 */
function expandMenuItem(e) {
	const { mainMenu } = this;
	if (e.target.classList.contains("dropdown-icon")) {
		const parentLi = e.target.closest("li");
		const subMenu = e.target.nextElementSibling;
		const links = subMenu.querySelectorAll(" & > li > a");
		const subMenuDropdownBtn = subMenu.querySelectorAll(" & > li > .dropdown-icon");
		// console.log(subMenu);
		e.target.classList.toggle("expanded");
		if (e.target.classList.contains("expanded")) {
			e.target.setAttribute("aria-expanded", true);
			subMenu.classList.add("expanded");
			// subMenu.setAttribute("tabindex", 0);

			links.forEach((link) => link.setAttribute("tabindex", 0));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		} else {
			e.target.setAttribute("aria-expanded", false);
			subMenu.classList.remove("expanded");
			// subMenu.setAttribute("tabindex", -1);
			links.forEach((link) => link.setAttribute("tabindex", -1));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		}
	}
	// console.log("pp");
}

function CloseSubmenuOnKeypress(e) {
	const { mainMenu } = this;
	const focusedElement = document.activeElement;
	parentLis = mainMenu.querySelectorAll(".parent-menu-item");
	if (e.target.classList.contains("parent-menu-item-link")) {
		const submenus = mainMenu.querySelectorAll(" .sub-menu");
		const links = mainMenu.querySelectorAll(" .sub-menu a");
		const subMenuDropdownBtn = mainMenu.querySelectorAll(".sub-menu .dropdown-icon");
		links.forEach((link) => link.setAttribute("tabindex", -1));
		subMenuDropdownBtn.forEach((btn) => {
			btn.setAttribute("aria-expanded", false);
			btn.setAttribute("tabindex", -1);
		});
		submenus.forEach((menu) => menu.classList.remove("expanded"));
	}
}
